import React, { useContext, useEffect } from "react";
// import { Button } from "react-bootstrap";
import { CgPlayListRemove } from "react-icons/cg";
import { AiOutlineCheck } from "react-icons/ai";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import { AuthContext } from "../../context/AuthContext";

const NotificacaoDetalhamento = ({ data: notificacao }) => {
  const { setUnreadNotifications } = useContext(AuthContext);
  const { request, data, requestId } = useApiClient();
  const { setRows, id, leitura } = notificacao;

  useEffect(() => {
    if (!leitura) request(apiRoutes.usuarios.notificacao.marcarComoLidas, { ids: [id] }, { requestId: id });
  }, [request, id, leitura]);

  useEffect(() => {
    if (data) {
      setUnreadNotifications((prev) => {
        const unread = prev.filter((item) => item.id !== +requestId);
        return [...unread];
      });

      if (typeof requestId === "string" && requestId.startsWith("trash-")) {
        // Exclusão
        setRows((prev) => {
          const idx = prev.findIndex((item) => item.id === +requestId.replace("trash-", ""));
          if (idx >= 0) prev.splice(idx, 1);
          return [...prev];
        });
      } else {
        // Leitura
        setRows((curr) => {
          const notificacaoLida = curr.find((item) => item.id === +requestId);
          if (notificacaoLida) notificacaoLida.leitura = new Date();
          return [...curr];
        });
      }
    }
  }, [data, requestId, setRows, setUnreadNotifications]);

  return notificacao.conteudo ? (
    <div className="text-left m-4">
      <ul className="list-group">
        <li className="list-group-item" key={notificacao.id}>
          <AiOutlineCheck className="text-success" />
          &nbsp;
          {notificacao.conteudo}
          <br />
          {/* <Button
            className="btn btn-primary btn-sm"
            onClick={() => {
              request(
                apiRoutes.usuarios.notificacao.marcarComoApagadas,
                { ids: [notificacao.id] },
                { requestId: `trash-${notificacao.id}` },
              );
            }}
          >
            Apagar
          </Button> */}
        </li>
      </ul>
    </div>
  ) : (
    <div className="text-center m-4">
      <CgPlayListRemove className="text-danger" />
      &nbsp;
      <span className="text-muted">(Sem mensagem adicional)</span>
    </div>
  );
};

export default NotificacaoDetalhamento;
